import React from 'react';

export interface ReadView {
    title?: string | React.ReactNode;
    data: {
        key: string;
        value: string | React.ReactNode;
        notShow?: boolean;
        width?: string;
        action?: boolean;
    }[];
    action?: React.ReactNode;
    isShowEmptyAction?: boolean;
}

type Props = {
    list: ReadView[];
};

const ReadOnly: React.FC<Props> = ({ list }) => {
    return (
        <div>
            {list.map((l, index) => (
                <div
                    key={`${index}_${l.title}`}
                    className={` rounded-lg  mt-1`}
                    style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F4F7FD' }}
                >
                    <div className="flex items-center justify-between">
                        {l.title ? (
                            <p className="text-[#142C53] text-2xl font-[WorkSans-Semibold] uppercase font-bold  my-1.5 common_read_title">
                                {l.title}
                            </p>
                        ) : (
                            <div />
                        )}
                        {l.action && <div className="mb-2">{l.action}</div>}
                    </div>
                    <div className="flex">
                        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                            {l.data.map(
                                (
                                    obj: {
                                        key: string;
                                        value: string | React.ReactNode;
                                        notShow?: boolean;
                                        width?: string;
                                        action?: boolean;
                                    },
                                    index1: number,
                                ) => (
                                    <div
                                        // className={`flex flex-col pb-4  ${
                                        //     obj.width ? obj.width : 'w-full md:w-1/2 lg:w-1/3 '
                                        // } p-2`}
                                        key={`${index1}_${index}_${obj.key}`}
                                        style={obj.notShow ? { display: 'none' } : {}}
                                    >
                                        {!obj.action && (
                                            <div className="w-full WorkSans pr-2 text-xs text-[#27AE60] truncate">
                                                {obj.key}
                                            </div>
                                        )}
                                        <div className="w-full text-sm WorkSans-Semibold text-[#142C53]">
                                            {obj.value}
                                        </div>
                                    </div>
                                ),
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ReadOnly;
